export const TRANSLATIONS_AR = {
    signupTitle: "التسجيل",
    signupHeader: "الرجاء إدخال المعلومات التالية لإنشاء حساب.",
    mobileNumber: "رقم الجوال",
    patientFirstname: "الاسم الأول للمريض",
    patientLastName: "اسم عائلة المريض",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    patientDob: "تاريخ ميلاد المريض",
    patientGender: "جنس المريض",
    male: "ذكر",
    female: "أنثى",
    zipCode: "الرمز البريدي",
    password: "كلمة المرور",
    whoIsFillingForm: "من يقوم بملء هذا النموذج؟",
    legalGuardian: "مقدم الرعاية",
    patient: "المريض",
    proceedButton: "متابعة",
    belowTwelveNote: "نظرًا لعمرك، نحتاج إلى مدخلات والدك أو والدتك. يرجى تسليم الجهاز لوالدك/والدتك أو الطلب منهما التسجيل.",
    parent: "نعم، أنا الوالد/الوالدة",
    notParent: "لا، لست الوالد/الوالدة",
    twelveToEighteenNote: "نظرًا لعمر المريض، نحتاج إلى مدخلاته. يرجى تسليم الجهاز للمريض للتسجيل إذا كان قادرًا على الإجابة على الاستبيان.",
    imPatient: "نعم، أنا المريض",
    notPatient: "لا، لست المريض",
    patientIncapable: "المريض غير قادر",
    legalGuardianTitle: "أدخل بياناتك",
    guardianFirstName: "الاسم الأول لمقدم الرعاية",
    guardianLastName: "اسم عائلة مقدم الرعاية",
    guardianEmail: "البريد الإلكتروني",
    emergencyContactTitle: "أدخل بيانات جهة الاتصال في حالات الطوارئ",
    emergencyFirstName: "الاسم الأول",
    emergencyLastName: "اسم العائلة",
    emergencyPhoneNumber: "رقم الهاتف",
    relationType: "نوع العلاقة",
    canShareDetail: "في حالة الطوارئ، هل يمكننا مشاركة بياناتك مع جهة الاتصال المذكورة أعلاه؟",
    yes: "نعم",
    no: "لا",
    reasonForVisitTitle: "سبب الزيارة",
    sickVisit: "زيارة بسبب المرض",
    annualVisit: "الفحص السنوي/الفحص الدوري",
    welcomeTitle: "مقدمة الفحص",
    welcomeSubTitle: "يرجى تحديد أي أعراض من خلال الإجابة على الأسئلة القادمة، سيستغرق ذلك من 8 إلى 10 دقائق من وقتك.",
    getStartedButton: "ابدأ الآن",
    adhdNote: "يجب إكمال الاستبيان التالي من قبل الوصي القانوني أو الوالد - يرجى تسليم الجهاز.",
    handoverButton: "تسليم",
    loginTitle: "تسجيل الدخول",
    loginSubTitle: "ستبقى معلوماتك آمنة وسرية.",
    forgotPassword: "نسيت كلمة المرور؟",
    forgotPasswordSubTitle: "يرجى إدخال رقم الهاتف الذي تستخدمه لتسجيل الدخول إلى Small Joys",
    backToLogin: "العودة إلى تسجيل الدخول",
    resetPassword: "إعادة تعيين كلمة المرور",
    resetPasswordSubTitle: "يرجى إنشاء كلمة مرور جديدة، يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    enterCodeTitle: "يرجى إدخال رمز التحقق المرسل إلى",
    change: "تغيير",
    verify: "تحقق",
    notReceivedCode: "لم تستلم الرمز؟",
    resendCode: "إعادة إرسال الرمز",
    completedScreener: "لقد أكملت فحصًا",
    nextScreener: "الانتقال إلى الفحص التالي",
    thankYou: "شكرًا لك!",
    completedQuestionnaires: "لقد أكملت جميع الاستبيانات.",
    handover: "يرجى تسليم الجهاز إلى الموظف المسؤول",
    suicidalTitle: "تحتاج إلى التحدث مع شخص ما اليوم",
    suicidalSubTitle: "إذا كنت تفكر في إيذاء نفسك، أو قلقًا بشأن صديق أو أحد أحبائك، أو ترغب في الحصول على دعم عاطفي، يرجى الاتصال بنا للتحدث معنا (متوفرون على مدار الساعة طوال أيام الأسبوع)",
    call: "اتصال",
    officialWebsite: "الموقع الرسمي",
    oneDrinkEquals: "المشروب الواحد يعادل",
    ozBeer: 'أونصة من البيرة',
    ozWine: 'أونصة من النبيذ',
    ozLiquor: 'أونصة من المشروبات الروحية',
    ozLiquorOneShot: 'جرعة واحدة',
    checkInCompleteTitle: 'اكتمل تسجيل الوصول',
    checkInCompleteMessage: 'شكرًا لتسجيل وصولك. يرجى التوجه إلى مكتب الاستقبال لمتابعة إجراءات موعدك.',
}